import { FileDown } from 'lucide-react'
import { useTranslation } from 'react-i18next'
import { Button } from '@/components/shadcn/button'
import { Tooltip, TooltipContent, TooltipProvider, TooltipTrigger } from '@/components/shadcn/tooltip'

const TEMPLATE_URL = '/files/templates/Mitarbeiterliste.xlsx'

export function TemplateDownloadButton() {
  const { t } = useTranslation('employees')
  return (
    <TooltipProvider>
      <Tooltip>
        <TooltipTrigger asChild>
          <Button variant="outline" size="icon" className="h-9 w-9" asChild>
            <a href={TEMPLATE_URL} download>
              <FileDown className="h-4 w-4" />
            </a>
          </Button>
        </TooltipTrigger>
        <TooltipContent>{t('actions.templateTooltip')}</TooltipContent>
      </Tooltip>
    </TooltipProvider>
  )
}
